import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['nestBrown', 0.77],
        ['shadow', 0.23],
      ],
      d: 'M-1.5,-1h0.5v1h-0.5zM1,-1h0.5v1h-0.5zM2,0h0.5v0.5h-0.5zM-2,0.5h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'nestBrown',
      d: 'M-2,-1h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5zM-2.5,-0.5h1v0.5h-1zM1.5,-0.5h1v0.5h-1zM-2.5,0h2.5v0.5h-2.5zM0.5,0h1.5v0.5h-1.5zM-1.5,0.5h2.5v0.5h-2.5z',
    },
    {
      paint: [
        ['nestBrown', 0.55],
        ['shadow', 0.45],
      ],
      d: 'M-1,-0.5h1v0.5h-1z',
    },
    { paint: 'eggBlue', d: 'M-1,-1.5h1v1h-1z' },
    { paint: 'eggWhite', d: 'M0.5,-1.5h0.5v0.5h-0.5zM0,-1h0.5v0.5h-0.5z' },
    {
      paint: [
        ['eggWhite', 0.38],
        ['nestBrown', 0.62],
      ],
      d: 'M0,-1.5h0.5v0.5h-0.5zM-2.5,-1h0.5v0.5h-0.5zM0.5,-1h0.5v0.5h-0.5zM0,-0.5h1v0.5h-1zM0,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 40,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: [
        ['nestBrown', 0.77],
        ['shadow', 0.23],
      ],
      d: 'M-1.5,-0.5h0.5v0.5h-0.5zM2,0h0.5v0.5h-0.5zM-2,0.5h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'nestBrown',
      d: 'M-2,-1h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5zM-2.5,-0.5h1v0.5h-1zM1.5,-0.5h1v0.5h-1zM-2.5,0h2.5v0.5h-2.5zM0.5,0h1.5v0.5h-1.5zM-1.5,0.5h2.5v0.5h-2.5z',
    },
    {
      paint: [
        ['nestBrown', 0.55],
        ['shadow', 0.45],
      ],
      d: 'M-0.5,-0.5h1v0.5h-1z',
    },
    { paint: 'eggBlue', d: 'M-1,-1.5h1.5v1h-1.5z' },
    { paint: 'eggWhite', d: 'M0.5,-1.5h0.5v1h-0.5z' },
    {
      paint: [
        ['eggWhite', 0.38],
        ['nestBrown', 0.62],
      ],
      d: 'M-2.5,-1h0.5v0.5h-0.5zM-1.5,-1h0.5v0.5h-0.5zM1,-1h0.5v0.5h-0.5zM-1,-0.5h0.5v0.5h-0.5zM0.5,-0.5h1v0.5h-1zM0,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 40,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: [
        ['nestBrown', 0.77],
        ['shadow', 0.23],
      ],
      d: 'M-1.5,-1h0.5v1h-0.5zM1,-1h0.5v1h-0.5zM2,0h0.5v0.5h-0.5zM-2,0.5h0.5v0.5h-0.5zM1,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'nestBrown',
      d: 'M-2,-1h0.5v0.5h-0.5zM1.5,-1h0.5v0.5h-0.5zM-2.5,-0.5h1v0.5h-1zM1.5,-0.5h1v0.5h-1zM-2.5,0h2.5v0.5h-2.5zM0.5,0h1.5v0.5h-1.5zM-1.5,0.5h2.5v0.5h-2.5z',
    },
    {
      paint: [
        ['nestBrown', 0.55],
        ['shadow', 0.45],
      ],
      d: 'M-0.5,-0.5h0.5v0.5h-0.5z',
    },
    { paint: 'eggBlue', d: 'M-1,-1.5h0.5v1h-0.5z' },
    { paint: 'winterBirdBrown', d: 'M0,-2h1.5v0.5h-1.5zM0,-1.5h1v0.5h-1z' },
    { paint: 'tulipYellow', d: 'M1,-1.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['eggWhite', 0.38],
        ['nestBrown', 0.62],
      ],
      d: 'M-0.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h0.5v0.5h-0.5zM-0.5,-1h1.5v0.5h-1.5zM-1,-0.5h0.5v0.5h-0.5zM0,-0.5h1v0.5h-1zM0,0h0.5v0.5h-0.5z',
    },
  ],
  pixels: 44,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
